module.exports = __webpack_public_path__ + "media/icons-for-sprite/settings-740c0fb0.svg";